module.exports = __webpack_public_path__ + "static/media/5-en.1b79d8d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/5-en.wav
// module id = hjXr
// module chunks = 1